import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';
const MODULE_PREFIX = '[ WAVE2 WATCHLIST ]';

const Actions = {
	fetchAllRecommendedWatchlist: `${MODULE_PREFIX} fetchAllRecommendedWatchlist`,
	fetchAllWatchlists: `${MODULE_PREFIX} fetchAllWatchlists`,
	setAllRecommendedWatchlist: `${MODULE_PREFIX} setAllRecommendedWatchlist`,
	createWatchlist: `${MODULE_PREFIX} createWatchlist`,
	updateWatchlistData: `${MODULE_PREFIX} updateWatchlistData`,
	resetWatchlistData: `${MODULE_PREFIX} resetWatchlistData`,
	setSelectedWatchlist: `${MODULE_PREFIX} setSelectedWatchlist`,
	deleteReorderWatchlist: `${MODULE_PREFIX} deleteReorderWatchlist`,
	updateWatchlistItems: `${MODULE_PREFIX} updateWatchlistItems`,
	updateWatchlist: `${MODULE_PREFIX} updateWatchlist`,
	deleteScripFromWatchlists: `${MODULE_PREFIX} deleteScripFromWatchlists`,
	updateScripsMarketData: `${MODULE_PREFIX} updateScripsMarketData`,
	updateWatchlistStorage: `${MODULE_PREFIX} updateWatchlistStorage`,
	setWatchlistLoader: `${MODULE_PREFIX} setWatchlistLoader`,
	setWatchlistError: `${MODULE_PREFIX} setWatchlistError`,
	getWatchlistGuestMarketData: `${MODULE_PREFIX} getWatchlistGuestMarketData`,
};

//actions
export const fetchAllRecommendedWatchlist = createAction(Actions.fetchAllRecommendedWatchlist);
export const fetchAllWatchlists = createAction(Actions.fetchAllWatchlists);
export const setAllRecommendedWatchlist = createAction(Actions.setAllRecommendedWatchlist);
export const createWatchlist = createAction(Actions.createWatchlist);
export const updateWatchlistData = createAction(Actions.updateWatchlistData);
export const resetWatchlistData = createAction(Actions.resetWatchlistData);
export const setSelectedWatchlist = createAction(Actions.setSelectedWatchlist);
export const deleteReorderWatchlist = createAction(Actions.deleteReorderWatchlist);
export const updateWatchlistItems = createAction(Actions.updateWatchlistItems);
export const updateWatchlist = createAction(Actions.updateWatchlist);
export const deleteScripFromWatchlists = createAction(Actions.deleteScripFromWatchlists);
export const updateScripsMarketData = createAction(Actions.updateScripsMarketData);
export const updateWatchlistStorage = createAction(Actions.updateWatchlistStorage);
export const setWatchlistLoader = createAction(Actions.setWatchlistLoader);
export const setWatchlistError = createAction(Actions.setWatchlistError);
export const getWatchlistGuestMarketData = createAction(Actions.getWatchlistGuestMarketData);

//Selector
export const getAllRecommendedWatchlists = (state) => {
	const recommendedWatchlist = get(state, 'watchlist.recommendedWatchlist', []);
	return recommendedWatchlist;
};

export const getWatchlistIdsArray = (state) => {
	const watchlistObject = get(state, 'watchlist.watchlistObject', {});
	const watchlistIdList = Object.keys(watchlistObject).sort(function (a, b) {
		return watchlistObject[a].sequence - watchlistObject[b].sequence;
	});

	return [...watchlistIdList];
};

export const getWatchlistData = (state) => {
	const watchlistObject = get(state, 'watchlist.watchlistObject', {});
	const watchlistNData = Object.keys(watchlistObject)
		.sort(function (a, b) {
			return watchlistObject[a].sequence - watchlistObject[b].sequence;
		})
		.map(function (sortedKey) {
			return { ...watchlistObject[sortedKey], id: sortedKey };
		});

	return [...watchlistNData];
};

export const getWatchlistObject = (state) => {
	const watchlistObject = get(state, 'watchlist.watchlistObject', {});
	return watchlistObject;
};

export const getWatchlistScripsObject = (state, id) => {
	const watchlistScripsObject = get(state, `watchlist.watchlistObject[${id}]`, {});
	return { ...watchlistScripsObject, id: id };
};

export const getSelectedWatchlist = (state) => {
	const selectedWatchlist = get(state, 'watchlist.selectedWatchlist', {});
	return selectedWatchlist;
};

export const getScripsMarketData = (state) => {
	const scripsMarketData = get(state, 'watchlist.scripsMarketData', []);
	return scripsMarketData;
};

export const getWatchlistStorage = (state) => {
	const watchlistStorage = get(state, 'watchlist.watchlistStorage', {});
	return watchlistStorage;
};

export const getWatchlistLoader = (state) => {
	const watchlistLoader = get(state, 'watchlist.isLoading', false);
	return watchlistLoader;
};

export const getWatchlistError = (state) => {
	const watchlistError = get(state, 'watchlist.wlLandingError', {});
	return watchlistError;
};

const initialStage = {
	isLoading: true,
	wlLandingError: {
		isFetchFailed: false,
		message: '',
	},
	recommendedWatchlist: [],
	watchlistObject: {},
	selectedWatchlist: {},
	scripsMarketData: {},
	watchlistStorage: {
		isWatchlistDataFetched: false,
	},
};

//reducer
export default createReducer(initialStage, (builder) => {
	builder.addCase(setAllRecommendedWatchlist, (state, action) => {
		state.recommendedWatchlist = action.payload;
	});
	builder.addCase(updateWatchlistData, (state, action) => {
		state.watchlistObject = { ...state.watchlistObject, ...action.payload };
	});
	builder.addCase(resetWatchlistData, (state, action) => {
		state.watchlistObject = action.payload;
	});
	builder.addCase(setSelectedWatchlist, (state, action) => {
		state.selectedWatchlist = { ...action.payload };
	});
	builder.addCase(updateScripsMarketData, (state, action) => {
		state.scripsMarketData = { ...state.scripsMarketData, ...action.payload };
	});
	builder.addCase(updateWatchlistStorage, (state, action) => {
		state.watchlistStorage = { ...state.watchlistStorage, ...action.payload };
	});
	builder.addCase(setWatchlistLoader, (state, action) => {
		state.isLoading = action.payload;
	});
	builder.addCase(setWatchlistError, (state, action) => {
		state.wlLandingError = action.payload;
	});
});
